@if (events.isLoading()) {
  <cue-loading />
} @else {
  <div #scrollable class="timeline-scroll overflow-x-scroll overflow-y-hidden w-full relative pt-3 mb-4">
    <div
      [ngStyle]="{
        background:
          'repeating-linear-gradient(90deg, transparent, transparent 0, #897878 0px, transparent 1px, transparent ' +
          (timelineSizes().quarterWidth * 4 - 1) +
          'px, #897878 ' +
          timelineSizes().quarterWidth * 4 +
          'px)',
        display: 'flex',
        width: totalWidth() + 'px',
      }"
    >
      @for (day of days(); track day) {
        <div
          [ngStyle]="{
            display: 'flex',
          }"
        >
          @for (hour of day.hours; track hour) {
            <div
              class="hour"
              [ngStyle]="{
                width: timelineSizes().quarterWidth * 4 + 'px',
              }"
            >
              <span>{{ hour }}</span>
            </div>
          }
        </div>
      }
    </div>

    <div class="now" [style.left.px]="nowLeft()">
      <span>{{ translation.common.now | transloco }}</span>
    </div>

    <div class="jeden-resource">
      @for (event of extractedEvents(); track trackEventsByFn($index, event)) {
        <div
          [class.free]="event.availability === '0' || event.availability === '5'"
          [class.assigned-to-you]="event.availability === '5'"
          [class.reserved]="event.availability === '2'"
          [class.closed]="event.availability === '3'"
          [class.limited]="event.availability === '4'"
          [ngStyle]="{
            'border-radius': '8px',
            background: getBackground(event.availability),
            width: event.width + 'px',
            height: '30px',
          }"
        ></div>
      }

      @for (item of scheduleEvents(); track item) {
        <div
          [cueTooltip]="eventOverlayTemplate"
          [cueTooltipPosition]="getPosition(item, scrollable)"
          [cueTooltipScrollStrategy]="'close'"
          [cueTooltiptOptions]="{ trigger: responsiveService.isMobile() ? 'click' : 'hover' }"
          [cueTooltipHasBackdrop]="responsiveService.isMobile()"
          cueTooltipBackdropClass="reserve-tooltip-mobile-backdrop"
          class="schedule-event"
          [style.width.px]="item.width"
          [style.min-width.px]="item.width"
          [style.left.px]="item.left"
          [style.max-width.px]="scrollable.clientWidth - 50"
          [ngStyle]="attendeeItemStyle(item)"
        >
          <div class="subject">
            {{ item.subject | subjectPipe }}
          </div>

          <ng-template #eventOverlayTemplate>
            <div
              [style.max-width.px]="scrollable.clientWidth - 180"
              [ngStyle]="attendeeItemStyle(item)"
              class="schedule-event-overlay"
            >
              @if (item.finished) {
                <div class="finished-status">
                  <p>{{ translation.common.finished | transloco }}</p>
                </div>
              }
              @if (item.cancelled) {
                <div class="flex flex-row justify-start w-full">
                  <div class="state desktop rejected">
                    <p>{{ translation.common.cancelled | transloco }}</p>
                  </div>
                </div>
              }
              <div class="subject" [class.is-finished]="item.finished">
                {{ item.subject | subjectPipe }}
              </div>
              @for (rA of item.resourceAttendees; track $index) {
                @if (rA.confirmationMetadata.confirmed) {
                  <span class="note default-hidden">
                    {{
                      translation.reservations.confirmed
                        | transloco
                          : {
                              when: (rA.confirmedWhen | dateTimeFormat),
                              who: rA.confirmedBy,
                            }
                    }}
                  </span>
                } @else {
                  @if (rA.confirmAvailable) {
                    <span class="note default-hidden">
                      {{
                        translation.reservations.confirmationRequiredUntil
                          | transloco
                            : {
                                until: (rA.confirmationMetadata.higherBorderTime | dateTimeFormat),
                                resourceName: (rA.resource | resourceTitle),
                              }
                      }}
                    </span>
                  } @else if (rA.status === 'need-confirmation') {
                    <span class="note default-hidden">
                      {{
                        getTextKeyForConfirmation(rA)
                          | transloco
                            : {
                                from: (rA.confirmationMetadata.lowerBorderTime | dateTimeFormat),
                                to: (rA.confirmationMetadata.higherBorderTime | dateTimeFormat),
                                resourceName: (rA.resource | resourceTitle),
                              }
                      }}
                    </span>
                  }
                }

                <div class="flex flex-row gap-3 items-center mb-1">
                  <div class="place">
                    <cue-icon [icon]="ICONS.cueMarker" />
                    <span>{{
                      (rA.resource.displayNameForApp | localizedString) ?? (rA.resource.displayName | localizedString)
                    }}</span>
                  </div>
                  @if (!item.cancelled) {
                    <div class="state" [ngClass]="getTextKeyAndClass(rA)[1]">
                      <p>{{ getTextKeyAndClass(rA)[0] | transloco }}</p>
                    </div>
                  }
                </div>
              }
              <div class="properties">
                <div class="pair">
                  <span class="key">
                    {{ translation.reservationPopup.organizer | transloco }}
                    :</span
                  >
                  <span class="value">{{ item.organizer.emailAddress.address }}</span>
                </div>

                @if (
                  !eventIsAllDay({
                    start: item.start.utcDateTime,
                    end: item.end.utcDateTime,
                  })
                ) {
                  <div class="pair">
                    <span class="key">{{ translation.leftMenu.from | transloco }} :</span>
                    <span class="value">{{ item.start.utcDateTime | dateTimeFormat }}</span>
                  </div>
                  <div class="pair">
                    <span class="key">{{ translation.leftMenu.to | transloco }} :</span>
                    <span class="value">{{ item.end.utcDateTime | dateTimeFormat }}</span>
                  </div>
                } @else {
                  <div class="pair">
                    <span class="key">{{ translation.reservationPopup.allDay | transloco }} :</span>
                    <span class="value">{{ item.start.utcDateTime | dateFormat }}</span>
                  </div>
                }

                @if (notResourceAttendeeLength(item.attendees, item.resourceAttendees) > 0) {
                  <h3 class="attendee-header">
                    {{ translation.reservationPopup.attendees | transloco }}
                  </h3>
                  @for (attendee of item.attendees; track attendee) {
                    @if (attendee.type !== 'resource') {
                      <div class="attendee-pair">
                        <b>{{ attendee.emailAddress.name }}</b
                        >({{ attendee.emailAddress.address }})
                      </div>
                    }
                  }
                }
              </div>
            </div>
          </ng-template>
        </div>
      }
    </div>
  </div>
  @if (reservationPosibilities()) {
    <div class="flex flex-col gap-4 w-full">
      <assist-availability-card
        [availableState]="reservationPosibilities()!.availableState"
        [from]="reservationPosibilities()!.from"
        [to]="reservationPosibilities()!.to"
      />
      <button cue-button size="default" class="xs-font-small w-full" (click)="onFavouriteReserve()">
        <cue-icon [icon]="ICONS.cueAdd" style="--icon-color: white" />
        {{ translation.menu.reserveButton | transloco }}
      </button>
    </div>
  }

  <div class="delimiter my-3"></div>
  <div class="flex flex-row justify-between w-full py-3 items-center font-bold">
    <h2>
      {{ translation.multiview.events.myReservationsTitle | transloco }}
    </h2>
    <span>
      {{ translation.multiview.events.myReservationsSubtitle | transloco }}
    </span>
  </div>

  @if (events.value().length === 0) {
    <div style="margin-top: 60px; margin-bottom: 60px" class="flex flex-col items-center justify-center w-full">
      <img src="assets/images/empty.png" width="81" height="60" />
      <span style="display: block">{{ translation.multiview.events.noReservations | transloco }}</span>
    </div>
  } @else {
    @for (event of events.value(); track event.id) {
      <assist-reservation-card
        showBigConfirmButton="true"
        [event]="event"
        [showImage]="false"
        [showNavigate]="false"
        confirmOnLabels="true"
        (cancelParticipation)="cancelParticipation($event)"
        (change)="changeEvent($event)"
        (confirm)="confirmEvent(event)"
        (navigate)="navigateEvent($event)"
        (delete)="deleteEvent($event)"
        (deleteSeries)="deleteSeriesEvent($event)"
        (detail)="detailEvent($event)"
        (finish)="finishEvent($event)"
        (show)="showOnFloorplan($event.resourceAttendee.resource, $event)"
        [isColleague]="false"
        [class.confirmation-required]="event.showConfirmButton"
      />
    }
  }
}
